import { getProposalGoods as getProposalGoodsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetProposalGoodsServiceRequest,
  GetProposalGoodsServiceResponse,
} from './get-proposal-goods.dto';
import {
  GetProposalGoodsServiceRequestSchema,
  GetProposalGoodsServiceResponseSchema,
} from './get-proposal-goods.dto';

export const getProposalGoodsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetProposalGoodsServiceRequestSchema),
    async (request: GetProposalGoodsServiceRequest): Promise<GetProposalGoodsServiceResponse> => {
      const apiResponse = await getProposalGoodsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 제안 상품 조회에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      return {
        list: apiResponse.data.list,
        total: apiResponse.link?.total ?? 0,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(GetProposalGoodsServiceResponseSchema),
  ),
);
